import React, { FC } from 'react';
import styled from 'styled-components/macro';
import media from 'styles/media';
import * as MESSAGES from 'constants/messages';
import { Card, ButtonS } from 'components/atoms';
import { ProfileGroupLabel } from 'components/molecules';
import { ProfileFormItems } from 'types/profile';
import CareerProfileJobHistoryContents from './CareerProfileJobHistoryContents';
import CareerProfileJobHistoryForm from './CareerProfileJobHistoryForm';
import { UpdateProfileCompletedModal } from '../Modals';
import useProfile from '../useProfile';

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 70px;

  ${media.mobile} {
    margin-bottom: 40px;
  }
`;

const ContentHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 32px;
  margin-bottom: 16px;

  ${media.mobile} {
    margin-bottom: 12px;
  }
`;

const ContentCard = styled(Card)`
  width: 100%;
`;

type CareerProfileJobHistoryProps = {
  formItems: ProfileFormItems;
};

const CareerProfileJobHistory: FC<CareerProfileJobHistoryProps> = props => {
  const { formItems } = props;
  const {
    canEdit,
    isEdit,
    handleShowContent,
    handleShowEdit,
    showUpdateProfileCompletedModal,
    openUpdateProfileCompletedModal,
    closeUpdateProfileCompletedModal,
  } = useProfile();

  return (
    <>
      <Wrapper>
        <ContentHead>
          <ProfileGroupLabel
            label={MESSAGES.PROFILE_SETTING.CAREER_JOB_HISTORY.LABEL}
            showInformation={isEdit}
          />
          {canEdit && !isEdit && (
            <ButtonS
              onClick={handleShowEdit}
              data-testid="button-edit-job-history"
            >
              {MESSAGES.PROFILE_SETTING.BUTTON.EDIT}
            </ButtonS>
          )}
        </ContentHead>
        <ContentCard>
          {isEdit ? (
            <CareerProfileJobHistoryForm
              formItems={formItems}
              onShowContent={handleShowContent}
              onOpenCompletedModal={openUpdateProfileCompletedModal}
            />
          ) : (
            <CareerProfileJobHistoryContents />
          )}
        </ContentCard>
      </Wrapper>
      <UpdateProfileCompletedModal
        show={showUpdateProfileCompletedModal}
        onClose={closeUpdateProfileCompletedModal}
      />
    </>
  );
};

export default CareerProfileJobHistory;
